import React, { useState } from 'react';
import { LiaPhoneVolumeSolid } from "react-icons/lia";
import { TiSocialLinkedin } from "react-icons/ti";
import { FaInstagram , FaTiktok  } from "react-icons/fa";
import { BiLogoFacebook } from "react-icons/bi";
import { GoArrowUp } from "react-icons/go";
import Input from './Input';
import styles from '../styles';
import phone24 from '../asstes/phone24.svg';
import emailcontact from '../asstes/emailcontact.svg';
import { useTranslation } from 'react-i18next';
import { sendContactData } from '../api/axios';
import SuccesPopup from './SuccesPupup';
import { BiSolidMessageError } from "react-icons/bi";
import {BsSendCheckFill} from 'react-icons/bs'

const ContactFooter = () => {
    const { t , i18n } = useTranslation();
    const isRTL = i18n.language === 'ar';

  const [message, setMessage] = useState({
    name : "",
    last_name:"",
    email : "",
    phone_number : "",
    message : ""
  })

  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const handleInput = (e) => {
      const { id, value } = e.target;
      setMessage(prev => ({
          ...prev,
          [id]: value
      }));
  };

  
  // Success popup state
  const [done , setDone] = useState(false)
  const [err , setErr] = useState(false)
  const closeDone = () => { setDone(!done) }
  const closeError = () => { setErr(!err) }
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await sendContactData(message);
      setDone(true);
      setMessage({
        name: "",
        last_name: "",
        email: "",
        phone_number: "",
        message: ""
      });
    } catch (error) {
      setErr(true);
    }
  };


  return (
    <section className={`relative ${isRTL ? '!font-cairo' : 'font-jakarta'}  w-full h-auto py-4 sm:py-10 lg:py-20 xl:py-28 px-4 sm:px-10 md:px-20 lg:px-12 xl:px-24 xxl:px-40 xxxl:px-68  ${isRTL ? 'rtl' : 'ltr'} rounded-[25px] bg-gradient-to-b from-primary via-primary to-thirdlygradient flex justify-center items-center `}>
        <style>
            {`
                @keyframes float {
                    0% { transform: translateY(0px); }
                    50% { transform: translateY(-10px); }
                    100% { transform: translateY(0px); }
                }
                .scroll-to-top {
                    animation: float 2s ease-in-out infinite;
                    transition: all 0.3s ease;
                }
                .scroll-to-top:hover {
                    transform: scale(1.1);
                }
            `}
        </style>
        <div className='w-full h-full flex flex-col-reverse gap-8 lg:flex-row lg:gap-0 justify-center rounded-xl xxxl:px-16 xxxxl:px-60'>
            <div className={`w-full lg:w-1/2 bg-white rounded-2xl p-5 sm:p-10 xxl:p-14 flex flex-col gap-2 md:gap-6 justify-center items-start `}>
                <div className=''>
                    <h1 className='text-[20px] lg:text-[30px] xxl:text-[46px] leading-10 xxl:leading-[61px] font-bold text-secondary'>{t('contact.callus')}</h1>
                </div>
                <div className='w-full flex flex-wrap lg:flex-nowrap items-center gap-2  md:gap-6 '>
                    <Input type='text' id='name' value={message.name} text={t('contactpage.form.name')}  onInput={handleInput} nolabel/>
                    <Input type='text' id='last_name' value={message.last_name} text={t('contactpage.form.lastName')}  onInput={handleInput} nolabel/>
                </div>
                <Input type='email' id='email' value={message.email} text={t('contactpage.form.email')} width='w-full' onInput={handleInput} nolabel />
                <Input type='text' id='phone_number' value={message.phone_number} text={t('contactpage.form.phone')}  width='w-full' onInput={handleInput} nolabel/>
                <Input type='text' id='message' value={message.message} text={t('contactpage.form.message')}  width='w-full' onInput={handleInput} nolabel/>
                <div className='w-full flex justify-center items-center'>
                    <button onClick={handleSubmit} className={`send bg-secondary w-1/2 h-auto py-2 leading-[25px]  text-[16px] text-white rounded-xl`}>{t('contactpage.form.button')}</button>
                </div>
            </div>
            <div className={`w-full lg:w-1/2 flex-col items-start md:items-end justify-between ${isRTL ? 'lg:pr-10 xl:pr-20' : 'lg:pl-10 xl:pl-20'}   `}>
                <div className='py-4 flex flex-col justify-center'>
                    <h1 className='text-[30px] sm:text-[46px] lg:text-[34px] xxl:text-[46px] leading-10 xl:leading-[61px] font-bold text-white py-2'>{t('contact.letusconnect')}</h1>
                    <div className='py-2'><div className='w-full h-0.5 bg-white rounded full opacity-[0.7]'></div></div>
                </div>
                <div className='flex flex-col gap-3 xl:gap-5'>
                   <h2 className='text-[25px] lg:text-[22px] xxl:text-[25px] leading-[30px] font-semibold text-white uppercase'>{t('contact.contactinfo')}</h2>
                   <div className=' flex gap-3'>
                        <a href={`tel:+212661267760`}><img src={phone24} alt='Contactez-Nous' className='w-[30px] sm:w-[35px]'/></a>
                        <span className='text-white font-[500] text-[14px] sm:text-[18px] lg:text-[16px] xxl:text-[20px] tracking-[2px] leading-[34px]'>{t('contactpage.contactcards.card4')}</span>
                   </div>
                   <div className=' flex gap-3'>
                        <a href='mailto:contact@cliniquemoulouya.ma'><img src={emailcontact} alt='Contactez-Nous' className='w-[30px] sm:w-[35px]'/></a>
                        <a href='mailto:contact@cliniquemoulouya.ma' className='text-white flex flex-col xs:flex-row font-[500] text-[14px] sm:text-[18px] lg:text-[16px] xxl:text-[20px] tracking-[2px] leading-[34px] cursor-pointer'>
                            <span >contact@</span>
                            <span>cliniquemoulouya.ma</span>
                        </a>
                   </div>
                   <div className=' flex items-center gap-3'>
                        <LiaPhoneVolumeSolid size={32} fill='#fff'/>
                        <div className='flex flex-col sm:gap-2 md:justify-between'>
                            <a href="tel:+212661267760" className='text-white font-[500] text-[14px] sm:text-[18px] lg:text-[16px] xxl:text-[20px] tracking-[2px] leading-[34px] cursor-pointer'>{t('contact.phone')}</a>
                            <a href="tel:+212536616869" className='text-white font-[500] text-[14px] sm:text-[18px] lg:text-[16px] xxl:text-[20px] tracking-[2px] leading-[34px] cursor-pointer'>{t('contact.phone1')}</a>
                        </div>
                   </div>
                   <div className=' flex items-center gap-4'>
                        <div className='bg-white p-2 rounded-full flex justify-center items-center'>
                            <a href='https://www.instagram.com/clinique_moulouya?igsh=bGVibGo5d2RsZWRn' target='_blank' rel='noopener noreferrer'><FaInstagram size={26} fill='#1376F8'/></a>
                        </div>
                        <div className='bg-white p-2 rounded-full flex justify-center items-center'>
                            <a href='https://www.facebook.com/CliniqueMoulouya?mibextid=ZbWKwL' target='_blank' rel='noopener noreferrer'><BiLogoFacebook size={28} fill='#1376F8'/></a>
                        </div>
                        <div className='bg-white p-3 rounded-full flex justify-center items-center'>
                            <a href='https://www.tiktok.com/@clinique_moulouya?_t=ZM-8ss0RAzDoUH&_r=1' target='_blank' rel='noopener noreferrer'><FaTiktok  size={20} fill='#1376F8'/></a>
                        </div>
                   </div>
                </div>
            </div>
        </div>
        <div className='scroll-to-top absolute top-2 right-2 sm:top-4 sm:right-4 lg:top-6 lg:right-6 xl:top-8 xl:right-8 bg-secondary p-2 lg:p-4 flex justify-center items-center rounded-full cursor-pointer' onClick={handleScrollToTop}>
            <GoArrowUp size={40} fill='#fff' />
        </div>
        {done && <SuccesPopup close={closeDone} icon={<BsSendCheckFill size={40} fill='#0f9b0f'/>} don={t('popup.succes')}/>}
        {err && <SuccesPopup close={closeError} icon={<BiSolidMessageError size={40} fill='#f00'/>} don={t('popup.error')} erorr/>}
    </section>
  )
}

export default ContactFooter